/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Other_ExtensionsInputs */

const en_domain_search_modal_other_extensions = /** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other extensions available`)
};

const es_domain_search_modal_other_extensions = /** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otras extensiones disponibles`)
};

const fr_domain_search_modal_other_extensions = /** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres extensions disponibles`)
};

const de_domain_search_modal_other_extensions = /** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere verfügbare Endungen`)
};

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const ja_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const zh_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const ar_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const id_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const it_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const ru_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const pt_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/** @type {(inputs: Domain_Search_Modal_Other_ExtensionsInputs) => LocalizedString} */
const ko_domain_search_modal_other_extensions = en_domain_search_modal_other_extensions;

/**
* | output |
* | --- |
* | "Other extensions available" |
*
* @param {Domain_Search_Modal_Other_ExtensionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_other_extensions = /** @type {((inputs?: Domain_Search_Modal_Other_ExtensionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Other_ExtensionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_other_extensions(inputs)
	if (locale === "es") return es_domain_search_modal_other_extensions(inputs)
	if (locale === "fr") return fr_domain_search_modal_other_extensions(inputs)
	if (locale === "de") return de_domain_search_modal_other_extensions(inputs)
	if (locale === "ja") return ja_domain_search_modal_other_extensions(inputs)
	if (locale === "zh") return zh_domain_search_modal_other_extensions(inputs)
	if (locale === "ar") return ar_domain_search_modal_other_extensions(inputs)
	if (locale === "id") return id_domain_search_modal_other_extensions(inputs)
	if (locale === "it") return it_domain_search_modal_other_extensions(inputs)
	if (locale === "ru") return ru_domain_search_modal_other_extensions(inputs)
	if (locale === "pt") return pt_domain_search_modal_other_extensions(inputs)
	return ko_domain_search_modal_other_extensions(inputs)
});